module.exports = __webpack_public_path__ + "sports_icon.svg?f90f3db2fef89eb85471d7fa122b38a3";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/sports_icon.svg
// module id = 1122
// module chunks = 33